 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTFM1_TITLEPAGE from '@/components/Text/FM1_TitlePage'
 import TEXTFM2_COPYRIGHT from '@/components/Text/FM2_Copyright'
 import TEXT1_BTT_TITLEPAGE from '@/components/Text/1_BTT_TITLEPAGE'
 import TEXT1_BTT_DEDICATION from '@/components/Text/1_BTT_Dedication'
 import TEXT1_BTT_N2780 from '@/components/Text/1_BTT_N2780'
 import TEXT1_BTT_N2781 from '@/components/Text/1_BTT_N2781'
 import TEXT1_BTT_N2782 from '@/components/Text/1_BTT_N2782'
 import TEXT1_BTT_N2783 from '@/components/Text/1_BTT_N2783'
 import TEXT1_BTT_N2784 from '@/components/Text/1_BTT_N2784'
 import TEXT1_BTT_N2785 from '@/components/Text/1_BTT_N2785'
 import TEXT1_BTT_N2786 from '@/components/Text/1_BTT_N2786'
 import TEXT1_BTT_N2787 from '@/components/Text/1_BTT_N2787'
 import TEXT1_BTT_N2788 from '@/components/Text/1_BTT_N2788'
 import TEXT1_BTT_N2790 from '@/components/Text/1_BTT_N2790'
 import TEXT1_BTT_N2791 from '@/components/Text/1_BTT_N2791'
 import TEXT1_BTT_N2792 from '@/components/Text/1_BTT_N2792'
 import TEXT1_BTT_N2793 from '@/components/Text/1_BTT_N2793'
 import TEXT1_BTT_N2794 from '@/components/Text/1_BTT_N2794'
 import TEXT1_BTT_N2795 from '@/components/Text/1_BTT_N2795'
 import TEXT1_BTT_N2796 from '@/components/Text/1_BTT_N2796'
 import TEXT1_BTT_N2797 from '@/components/Text/1_BTT_N2797'
 import TEXT1_BTT_N2798 from '@/components/Text/1_BTT_N2798'
 import TEXT1_BTT_N2799 from '@/components/Text/1_BTT_N2799'
 import TEXT1_BTT_N2800 from '@/components/Text/1_BTT_N2800'
 import TEXT1_BTT_N2801 from '@/components/Text/1_BTT_N2801'
 import TEXT1_BTT_N2802 from '@/components/Text/1_BTT_N2802'
 import TEXT1_BTT_N2803 from '@/components/Text/1_BTT_N2803'
 import TEXT1_BTT_N2804 from '@/components/Text/1_BTT_N2804'
 import TEXT1_BTT_N2805 from '@/components/Text/1_BTT_N2805'
 import TEXT1_BTT_N2806 from '@/components/Text/1_BTT_N2806'
 import TEXT1_BTT_N2807 from '@/components/Text/1_BTT_N2807'
 import TEXT1_BTT_N2808 from '@/components/Text/1_BTT_N2808'
 import TEXT1_BTT_N2809 from '@/components/Text/1_BTT_N2809'
 import TEXT1_BTT_N2810 from '@/components/Text/1_BTT_N2810'
 import TEXT1_BTT_N2811 from '@/components/Text/1_BTT_N2811'
 import TEXT1_BTT_N2812 from '@/components/Text/1_BTT_N2812'
 import LOVE_2 from '@/components/love_2'
 import TEXT1_BTT_ACKNOW from '@/components/Text/1_BTT_Acknow'
 import TEXT2_AON_TITLEPAGE from '@/components/Text/2_AON_TITLEPAGE'
 import TEXT2_AON_DEDICATION from '@/components/Text/2_AON_Dedication'
 import TEXT2_AON_N3616 from '@/components/Text/2_AON_N3616'
 import TEXT2_AON_N3617 from '@/components/Text/2_AON_N3617'
 import TEXT2_AON_N3618 from '@/components/Text/2_AON_N3618'
 import TEXT2_AON_N3619 from '@/components/Text/2_AON_N3619'
 import TEXT2_AON_N3620 from '@/components/Text/2_AON_N3620'
 import TEXT2_AON_N3621 from '@/components/Text/2_AON_N3621'
 import TEXT2_AON_N3622 from '@/components/Text/2_AON_N3622'
 import TEXT2_AON_N3623 from '@/components/Text/2_AON_N3623'
 import TEXT2_AON_N3624 from '@/components/Text/2_AON_N3624'
 import TEXT2_AON_N3625 from '@/components/Text/2_AON_N3625'
 import TEXT2_AON_N3626 from '@/components/Text/2_AON_N3626'
 import TEXT2_AON_N3627 from '@/components/Text/2_AON_N3627'
 import TEXT2_AON_N3628 from '@/components/Text/2_AON_N3628'
 import TEXT2_AON_N3629 from '@/components/Text/2_AON_N3629'
 import TEXT2_AON_N3630 from '@/components/Text/2_AON_N3630'
 import TEXT2_AON_N3631 from '@/components/Text/2_AON_N3631'
 import TEXT2_AON_N3632 from '@/components/Text/2_AON_N3632'
 import TEXT2_AON_N3633 from '@/components/Text/2_AON_N3633'
 import TEXT2_AON_N3634 from '@/components/Text/2_AON_N3634'
 import TEXT2_AON_N3635 from '@/components/Text/2_AON_N3635'
 import TEXT2_AON_N3636 from '@/components/Text/2_AON_N3636'
 import TEXT2_AON_N3637 from '@/components/Text/2_AON_N3637'
 import TEXT2_AON_N3638 from '@/components/Text/2_AON_N3638'
 import TEXT2_AON_N3639 from '@/components/Text/2_AON_N3639'
 import TEXT2_AON_N3640 from '@/components/Text/2_AON_N3640'
 import TEXT2_AON_N3641 from '@/components/Text/2_AON_N3641'
 import TEXT2_AON_N3642 from '@/components/Text/2_AON_N3642'
 import TEXT2_AON_N3643 from '@/components/Text/2_AON_N3643'
 import TEXT2_AON_ACKNOW from '@/components/Text/2_AON_Acknow'
 import TEXT3_AIF_TITLEPAGE from '@/components/Text/3_AIF_TITLEPAGE'
 import TEXT3_AIF_DEDICATION from '@/components/Text/3_AIF_Dedication'
 import TEXT3_AIF_N5437 from '@/components/Text/3_AIF_N5437'
 import TEXT3_AIF_N5438 from '@/components/Text/3_AIF_N5438'
 import TEXT3_AIF_N5439 from '@/components/Text/3_AIF_N5439'
 import TEXT3_AIF_N5440 from '@/components/Text/3_AIF_N5440'
 import TEXT3_AIF_N5441 from '@/components/Text/3_AIF_N5441'
 import TEXT3_AIF_N5444 from '@/components/Text/3_AIF_N5444'
 import TEXT3_AIF_N5445 from '@/components/Text/3_AIF_N5445'
 import TEXT3_AIF_N5446 from '@/components/Text/3_AIF_N5446'
 import TEXT3_AIF_N5447 from '@/components/Text/3_AIF_N5447'
 import TEXT3_AIF_N5448 from '@/components/Text/3_AIF_N5448'
 import TEXT3_AIF_N5449 from '@/components/Text/3_AIF_N5449'
 import TEXT3_AIF_N5450 from '@/components/Text/3_AIF_N5450'
 import TEXT3_AIF_N5451 from '@/components/Text/3_AIF_N5451'
 import TEXT3_AIF_N5452 from '@/components/Text/3_AIF_N5452'
 import TEXT3_AIF_N5453 from '@/components/Text/3_AIF_N5453'
 import TEXT3_AIF_N5454 from '@/components/Text/3_AIF_N5454'
 import TEXT3_AIF_N5455 from '@/components/Text/3_AIF_N5455'
 import TEXT3_AIF_N5456 from '@/components/Text/3_AIF_N5456'
 import TEXT3_AIF_N5457 from '@/components/Text/3_AIF_N5457'
 import TEXT3_AIF_N5458 from '@/components/Text/3_AIF_N5458'
 import TEXT3_AIF_N5459 from '@/components/Text/3_AIF_N5459'
 import TEXT3_AIF_N5460 from '@/components/Text/3_AIF_N5460'
 import TEXT3_AIF_N5461 from '@/components/Text/3_AIF_N5461'
 import TEXT3_AIF_N5462 from '@/components/Text/3_AIF_N5462'
 import TEXT3_AIF_N5463 from '@/components/Text/3_AIF_N5463'
 import TEXT3_AIF_N5464 from '@/components/Text/3_AIF_N5464'
 import TEXT3_AIF_N5465 from '@/components/Text/3_AIF_N5465'
 import TEXT3_AIF_N5466 from '@/components/Text/3_AIF_N5466'
 import TEXT3_AIF_N5467 from '@/components/Text/3_AIF_N5467'
 import TEXT3_AIF_N5468 from '@/components/Text/3_AIF_N5468'
 import TEXT3_AIF_ACKNOW from '@/components/Text/3_AIF_ACKNOW'
 import TEXTBM1_ABA from '@/components/Text/BM1_ABA'
 import TEXTBM2_CONNECTWDB from '@/components/Text/BM2_CONNECTWDB'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/Text/FM1_TitlePage",
 			"name" : "Text/FM1_TitlePage",
 			"component" : TEXTFM1_TITLEPAGE
 		},
 		{
 			"path" : "/Text/FM2_Copyright",
 			"name" : "Text/FM2_Copyright",
 			"component" : TEXTFM2_COPYRIGHT
 		},
 		{
 			"path" : "/Text/1_BTT_TITLEPAGE",
 			"name" : "Text/1_BTT_TITLEPAGE",
 			"component" : TEXT1_BTT_TITLEPAGE
 		},
 		{
 			"path" : "/Text/1_BTT_Dedication",
 			"name" : "Text/1_BTT_Dedication",
 			"component" : TEXT1_BTT_DEDICATION
 		},
 		{
 			"path" : "/Text/1_BTT_N2780",
 			"name" : "Text/1_BTT_N2780",
 			"component" : TEXT1_BTT_N2780
 		},
 		{
 			"path" : "/Text/1_BTT_N2781",
 			"name" : "Text/1_BTT_N2781",
 			"component" : TEXT1_BTT_N2781
 		},
 		{
 			"path" : "/Text/1_BTT_N2782",
 			"name" : "Text/1_BTT_N2782",
 			"component" : TEXT1_BTT_N2782
 		},
 		{
 			"path" : "/Text/1_BTT_N2783",
 			"name" : "Text/1_BTT_N2783",
 			"component" : TEXT1_BTT_N2783
 		},
 		{
 			"path" : "/Text/1_BTT_N2784",
 			"name" : "Text/1_BTT_N2784",
 			"component" : TEXT1_BTT_N2784
 		},
 		{
 			"path" : "/Text/1_BTT_N2785",
 			"name" : "Text/1_BTT_N2785",
 			"component" : TEXT1_BTT_N2785
 		},
 		{
 			"path" : "/Text/1_BTT_N2786",
 			"name" : "Text/1_BTT_N2786",
 			"component" : TEXT1_BTT_N2786
 		},
 		{
 			"path" : "/Text/1_BTT_N2787",
 			"name" : "Text/1_BTT_N2787",
 			"component" : TEXT1_BTT_N2787
 		},
 		{
 			"path" : "/Text/1_BTT_N2788",
 			"name" : "Text/1_BTT_N2788",
 			"component" : TEXT1_BTT_N2788
 		},
 		{
 			"path" : "/Text/1_BTT_N2790",
 			"name" : "Text/1_BTT_N2790",
 			"component" : TEXT1_BTT_N2790
 		},
 		{
 			"path" : "/Text/1_BTT_N2791",
 			"name" : "Text/1_BTT_N2791",
 			"component" : TEXT1_BTT_N2791
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js